<nz-spin [nzSpinning]="isLoading()">
  <form nz-form nzLayout="vertical" [formGroup]="jobsForm" class="job-form" (ngSubmit)="submitForm()">
    <div formArrayName="jobs">
      @for (jobControl of jobsArray.controls; track jobControl; let i = $index) {
        <div [formGroupName]="i" class="job-entry">
          <div class="job-entry-header">
            <span class="job-entry-title">Job {{ i + 1 }}</span>
            @if (jobsArray.length > 1) {
              <button nz-button nzType="text" nzDanger nzSize="small" type="button"
                (click)="removeJobEntry(i)" nz-tooltip nzTooltipTitle="Remove this entry">
                <span nz-icon nzType="delete" nzTheme="outline"></span>
              </button>
            }
          </div>

          <nz-form-item>
            <nz-form-label nzRequired nzFor="job_basepath_{{ i }}">Job Base Path</nz-form-label>
            <nz-form-control [nzErrorTip]="basePathErrorTpl">
              <input placeholder="Job base path" nz-input formControlName="job_basepath" id="job_basepath_{{ i }}" />
            </nz-form-control>
          </nz-form-item>

          <div nz-row [nzGutter]="16">
            <div nz-col [nzXs]="12">
              <nz-form-item>
                <nz-form-label nzFor="parent_job_{{ i }}">Parent Job</nz-form-label>
                <nz-form-control>
                  <nz-select formControlName="parent_job" nzShowSearch [nzFilterOption]="searchFn"
                    nzPlaceHolder="Select Parent Job" id="parent_job_{{ i }}">
                    <nz-option nzLabel="No Parent Job"></nz-option>
                    @for (job of parentJobs(); track job) {
                      <nz-option [nzLabel]="job.job_name" [nzValue]="job"></nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzXs]="12">
              <nz-form-item>
                <nz-form-label nzFor="parent_cp_{{ i }}">Parent CP Number</nz-form-label>
                <nz-form-control nzErrorTip="You must provide a parent CP number!">
                  <nz-input-number style="width: 100%" nz-input type="number" noScrollNumber
                    formControlName="parent_cp" [nzMin]="0" [nzMax]="getParentMaxIteration(i)"
                    nzPlaceHolder="Checkpoint #" id="parent_cp_{{ i }}">
                  </nz-input-number>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>

          <div nz-row [nzGutter]="16">
            <div nz-col [nzXs]="12">
              <nz-form-item>
                <nz-form-label nzFor="owner_{{ i }}">Job Owner</nz-form-label>
                <nz-form-control>
                  <nz-select formControlName="owner" nzShowSearch nzPlaceHolder="Select Job Owner"
                    [nzDisabled]="availableJobOwners().length === 0">
                    @for (u of availableJobOwners(); track u) {
                      <nz-option [nzValue]="u" [nzLabel]="u.email"></nz-option>
                    }
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzXs]="12" nzSm="6">
              <nz-form-item>
                <nz-form-control
                  nzExtra="In the case that NX2 > NX1, you may want to swap the 2 axis for visualization. Click on the checkbox if you'd like to do so.">
                  <label nz-checkbox formControlName="x2_is_inline">Swap Dimensions?</label>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col [nzXs]="12" nzSm="6">
                <nz-form-item>
                  <nz-form-control
                    nzExtra="Should be selected if the job/data is on AWS. If the job is local, set to false.">
                    <label nz-checkbox formControlName="is_aws">Is the data on AWS?</label>
                  </nz-form-control>
                </nz-form-item>
              </div>
          </div>
        </div>
      }
    </div>

    <button nz-button nzType="dashed" type="button" (click)="addJobEntry()" class="add-btn">
      <span nz-icon nzType="plus" nzTheme="outline"></span>
      Add Another Job
    </button>

    <div class="form-footer">
      <span class="job-count">{{ jobsArray.length }} job(s) to submit</span>
      <button nz-button nzType="primary" type="submit">
        Submit {{ jobsArray.length > 1 ? "All" : "" }}
      </button>
    </div>
  </form>
</nz-spin>


<ng-template #basePathErrorTpl let-control>
  @if (control.hasError('required')) {
    Job base path is required!
  } @else if (control.hasError('pattern')) {
    Must be an absolute path starting with a forward slash (e.g., /my-path).
  } @else if (control.hasError('minlength')) {
    Path must be at least 1 character long.
  } 
</ng-template>